"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleAggregator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksUtils = require("@titelmedia/bricks-utils");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CardItem = props => {
  const {
    image,
    mobileImage,
    title,
    subtitle,
    cta,
    url,
    cardTextPosition,
    headingOverlay,
    blackOverlay,
    hoverState,
    fontColor,
    fullHeight,
    imagePadding
  } = props;
  const fluid = image?.fluid || image?.responsiveImage || image;
  const mobileFluid = mobileImage?.fluid || mobileImage?.responsiveImage || mobileImage;
  const articleLink = event => {
    event?.preventDefault();
    window.location.href = url;
  };
  return _react.default.createElement(_styles.CardWrapper, {
    aspectRatio: fluid.aspectRatio,
    imagePadding: imagePadding,
    hoverState: hoverState,
    onClick: articleLink
  }, fluid && _react.default.createElement(_styles.Image, {
    src: fluid.src,
    headingOverlay: headingOverlay,
    blackOverlay: blackOverlay,
    aspectRatio: fluid.aspectRatio,
    fullHeight: fullHeight,
    desktop: true
  }), mobileFluid && _react.default.createElement(_styles.Image, {
    src: mobileFluid.src,
    blackOverlay: blackOverlay,
    mobile: true
  }), (title || subtitle || cta) && _react.default.createElement(_styles.CardContent, {
    cardTextPosition: cardTextPosition
  }, _react.default.createElement(_styles.CardInfo, {
    headingOverlay: headingOverlay,
    fontColor: fontColor?.hex || fontColor
  }, title && _react.default.createElement(_styles.CardTitle, null, title), subtitle && _react.default.createElement(_styles.CardSubtitle, null, subtitle), cta && _react.default.createElement(_styles.CardCTA, {
    onClick: articleLink
  }, _react.default.createElement(_styles.CardCtaText, {
    className: "article-aggregator-cta"
  }, cta)))));
};
const ArticleAggregator = ({
  titleImage,
  titleMobileImage,
  title,
  subtitle,
  fontColor,
  headingOverlay = false,
  blackOverlay,
  scrollCue = false,
  textPosition = 'top',
  cardTextPosition = 'bottom',
  hoverState = false,
  fullHeight = false,
  imagePadding = true,
  articleAggregatorItems
}) => {
  const fluid = titleImage?.fluid || titleImage?.responsiveImage || titleImage;
  const mobileFluid = titleMobileImage?.fluid || titleMobileImage?.responsiveImage || titleMobileImage;
  const containerRef = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!containerRef.current) return;
    const {
      offsetWidth
    } = containerRef.current;
    _bricksUtils.gsap.matchMedia().add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
      _bricksUtils.gsap.effects.horizontal(containerRef.current, {
        x: `-=${offsetWidth - window.innerWidth}px`,
        ease: 'power2.inOut',
        trigger: wrapperRef.current,
        end: `+=${offsetWidth}`,
        anticipatePin: 0.5
      });
    });
    let aggregatorAnimation = _bricksUtils.gsap.effects.fade(containerRef.current, {
      trigger: wrapperRef.current
    });
    return () => {
      if (aggregatorAnimation) aggregatorAnimation.kill();
    };
  }, []);
  return _react.default.createElement(_styles.Wrapper, {
    ref: wrapperRef
  }, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.ContainerDiv, {
    ref: containerRef,
    headingOverlay: headingOverlay,
    fullHeight: fullHeight
  }, _react.default.createElement(_styles.Headline, {
    hasFluid: fluid !== (undefined || null),
    headingOverlay: headingOverlay,
    fontColor: fontColor?.hex || fontColor,
    imagePadding: imagePadding
  }, fluid && _react.default.createElement(_styles.Image, {
    headingOverlay: headingOverlay,
    src: fluid.src,
    srcSet: fluid.srcSet,
    aspectRatio: fluid.aspectRatio,
    blackOverlay: blackOverlay,
    fullHeight: fullHeight,
    desktop: true
  }), mobileFluid && _react.default.createElement(_styles.Image, {
    src: mobileFluid.src,
    srcSet: mobileFluid.srcSet,
    blackOverlay: blackOverlay,
    mobile: true
  }), title && _react.default.createElement(_styles.TitleWrapper, {
    headingOverlay: headingOverlay,
    textPosition: textPosition
  }, _react.default.createElement(_styles.TitleContainer, null, _react.default.createElement(_styles.Title, null, title), subtitle && _react.default.createElement(_styles.Subtitle, null, subtitle), scrollCue && _react.default.createElement(_styles.ScrollExperienceWrapper, null, _react.default.createElement(_styles.ScrollExperienceContainer, null, _react.default.createElement(_styles.ScrollExperienceText, null, "SCROLL TO CONTINUE")), _react.default.createElement(_styles.ScrollExperienceContainer, null, _react.default.createElement(_styles.ScrollExperienceText, null, "SCROLL TO CONTINUE")))))), _react.default.createElement(_styles.ItemsContainer, null, articleAggregatorItems?.map((item, i) => {
    return _react.default.createElement(CardItem, _extends({
      key: `aggregator-item--${i}`,
      cardTextPosition: cardTextPosition,
      headingOverlay: headingOverlay,
      fontColor: fontColor,
      fullHeight: fullHeight,
      imagePadding: imagePadding,
      blackOverlay: blackOverlay,
      hoverState: hoverState
    }, item));
  }))));
};
exports.ArticleAggregator = ArticleAggregator;
//# sourceMappingURL=index.js.map